import { SPORTS } from '../data/constants';
import Stats from './Stats';
import DraftResumePrompt from './DraftResumePrompt';
import { RECORD_DRAFT_RESUME_KEY } from '../utils/recordDraft';

const toDateStr = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const parseDateStr = dateStr => {
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d);
};

function getWeekData(records) {
    const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const dow = today.getDay();
    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(today); d.setDate(today.getDate() - dow + i);
        const ds = toDateStr(d);
        const recs = records.filter(r => r.date === ds);
        return {
            name: dayNames[i], ds, recs,
            color: recs.length ? (SPORTS[recs[0].sport]?.color || '#888') : 'var(--bg3)',
            h: recs.length ? Math.min(40, 12 + recs.length * 10) : 4,
        };
    });
}

function isThisWeek(dateStr) {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const dow = today.getDay();
    const weekStart = new Date(today); weekStart.setDate(today.getDate() - dow);
    const d = parseDateStr(dateStr); d.setHours(0, 0, 0, 0);
    return d >= weekStart && d <= today;
}

export default function Home({ records, weights, goals, setGoals, promotions, setTab, showToast }) {
    const week = getWeekData(records);
    const todayDs = toDateStr(new Date());
    const thisWeek = records.filter(r => isThisWeek(r.date));
    const totalMin = records.reduce((a, r) => a + (+r.duration || 0), 0);

    return (
        <>
            {/* 요약 */}
            <div className="stats-row">
                <div className="stat-card"><div className="stat-val">{records.length}개</div><div className="stat-label">총 기록</div></div>
                <div className="stat-card"><div className="stat-val">{thisWeek.length}개</div><div className="stat-label">이번 주 기록</div></div>
                <div className="stat-card"><div className="stat-val">{Math.round(totalMin / 60) || 0}h</div><div className="stat-label">총 시간</div></div>
            </div>

            {/* 주간 바 */}
            <div className="week-bar">
                <div className="week-days">
                    {week.map(d => (
                        <div key={d.ds} className={`day-col${d.ds === todayDs ? ' is-today' : ''}`}>
                            <div className="day-name">{d.name}</div>
                            <div className="day-bar-wrap">
                                <div className="day-bar" style={{ height: d.h, background: d.color }} />
                            </div>
                            <div className="day-count">{d.recs.length}</div>
                            <div className="day-dot" style={{ background: d.recs.length ? d.color : 'var(--bg3)' }} />
                        </div>
                    ))}
                </div>
            </div>

            <Stats records={records} weights={weights} goals={goals} setGoals={setGoals} promotions={promotions} showGoals={false} />
            <DraftResumePrompt
                showToast={showToast}
                onResume={() => {
                    sessionStorage.setItem(RECORD_DRAFT_RESUME_KEY, '1');
                    setTab('add');
                }}
            />
        </>
    );
}
